import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoginPage } from '../features/auth/components/LoginPage';
import { DEFAULT_DASHBOARD_NODE_KEY } from '../features/dashboard/constants';
import { z } from 'zod';

const loginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: ({ context }) => {
    // If already authenticated, redirect to dashboard
    const contextWithStore = context as {
      store?: {
        getState: () => {
          auth?: { isAuthenticated?: boolean; homePageUrl?: string | null };
        };
      };
    };
    const state = contextWithStore.store?.getState();
    if (state?.auth?.isAuthenticated) {
      const homePageUrl = state.auth.homePageUrl;
      const redirectPath = homePageUrl?.startsWith('/') ? homePageUrl : '/';
      throw redirect({
        to: redirectPath,
        search: redirectPath === '/' ? { nodeKey: DEFAULT_DASHBOARD_NODE_KEY } : undefined,
      });
    }
  },
  component: LoginPage,
});
